export const GA_SEND_EVENT = 'GA_SEND_EVENT' // message type

// Event names are case sensitive. For example, my_event and My_Event are two distinct events.
// Use only letters, numbers, and underscores. Don't use spaces. Names must start with a letter.
// https://support.google.com/analytics/answer/10085872

// Event Names
export const BOTHEAD_MOUNT_ON_LISTING = 'bothead_mount_on_listing'
export const LISTING_EVAL_SLIDER_MOVED = 'listing_eval_slider_moved'
export const MONTHLY_COST_EDIT_CLICKED = 'monthly_cost_edit_clicked'
export const EDIT_ESTIMATED_COSTS_TEASER_CLICK =
  'edit_estimated_costs_teaser_click'
